import { LuSearch, BsThreeDots } from "@/Components/Icons/Icons";

export default {
  row1: [
    {
      column: "column1",
      // columnWidth: "100%",
      rows: {
        row1: [
          {
            name: "importInvoiceNumber",
            label: "Invoice Number",
            component: "text-field",
            width: "50%",
            required: true,
          },
          {
            name: "importInvoiceDate",
            label: "Date",
            component: "dateselector",
            width: "50%",
          },
        ],
        row2: [
          {
            name: "importCurrency",
            label: "Currency",
            component: "text-field",
            width: "25%",
            endpoint: "getExchange",
            labelKey: "label",
            responseKey: "data",
            valueKey: "value",
            type: "autocomplete",
            icon: LuSearch,
            autofillTargets: {
              currencyValue: "rate",
            },
            required: true,
          },
          {
            name: "currencyValue",
            label: "Currency Current Value",
            component: "text-field",
            width: "25%",
            dataType: "float",
          },
          {
            name: "importInvoiceTOI",
            label: "TOI & Place",
            component: "dropdown",
            width: "25%",
            endIconName: "LuChevronDown",
            defaultValue: "FOB",
            required: true,
            options: [
              { label: "FOB", value: "FOB" },
              { label: "CIF", value: "CIF" },
              { label: "C&F", value: "C&F" },
              { label: "C&I", value: "C&I" },
            ],
          },
          {
            name: "importInvoiceTOIPlace",
            component: "text-field",
            width: "25%",
          },
        ],
        row3: [
          {
            name: "importProductValue",
            label: "Product Value",
            component: "text-field",
            width: "50%",
            dataType: "float",
          },
          {
            name: "Charges",
            component: "outlinebutton",
            sx: {
              mt: "33px",
            },
            width: "10%",
            iconName: BsThreeDots,
            iconPosition: "start",
            iconSpacing: 0,
            action: "openSubDialog",
            subComponent: "MisCharge",  // 👈 what to open
          },
          {
            name: "ishasSampleItems",
            checkboxLabel: "Has Sample Items",
            component: "checkboxbox",
            sx: {
              mt: 4,
            },
          },
        ],
        row5: [
          {
            name: "ReCalc.Lic Values",
            label: "ReCalc.Lic Values",
            component: "outlinebutton",
            width: "30%",
          },
          {
            name: "importInvoiceValue",
            component: "text-field",
            visible: false,
          },
          {
            name: "otherCharges",
            component: "text-field",
            visible: false,
          },

          
        ],
      },
    },
  ],
};
